import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useSearchParams, useNavigate } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import logo from "../../assests/images/launch-wild-logo.png";

const ResetPassword = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const userId = searchParams.get("id") ?? "";
  const token = searchParams.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleResetPassword = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    (async () => {
      const response = await axiosOpen.patch("user/resetPassword", {
        userId,
        token,
        password,
      });
      navigate("/login");
      setError("");
    })();
  };

  return (
    <div className="reset-password-page">
      <div className="reset-form-wrapper">
        <div className="reset-password-container">
          <div className="logo-container">
            <img src={logo} alt="Product Logo" width="180" height="auto" style={{ "display": "block" }} />
          </div>
          <h1 className="text-center text-white my-2">New Password</h1>
          <Form className="form" onSubmit={handleResetPassword}>
            <Form.Floating>
              <Form.Control
                className="mb-3"
                id="floatingPasswordCustom"
                type="password"
                placeholder="Password"
                autoComplete="off"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                required
              />
              <label htmlFor="floatingPasswordCustom">Password</label>
            </Form.Floating>
            <Form.Floating>
              <Form.Control
                className="mb-3"
                id="floatingPasswordCustom"
                type="password"
                placeholder="Password"
                autoComplete="off"
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                required
              />
              <label htmlFor="floatingPasswordCustom">Confirm Password</label>
            </Form.Floating>
            {error && <div className="text-danger text-center">{error}</div>}
            <Button type="submit" variant="primary" className="text-decoration-none text-white w-100 ">
              Reset Password
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
